import FixedNavBar from "@/components/fixedNavBar";
import useCustomTranslation from "@/hooks/useTranslation";
import {
	dateFormat,
	east8ToEast9,
	formatNumberWithCommas,
	multiplyWithPrecision,
	pxToRem,
} from "@/util/common";
import { Button, Image, Space, Grid } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import { createUseStyles } from "react-jss";
import { EyeOutline, EyeInvisibleOutline } from "antd-mobile-icons";
import useRouter from "@/hooks/useRouter";
import GiftPopup from "../Game/comp/giftPopup";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import { has, isEmpty } from "lodash";
import { showGlobalLoading } from "@/components/globalLoading";
import API from "@/api";
import { useFinanceOrderList } from "@/hooks/useOrderRecords";
import CustomEmpty from "@/components/Empty";
import { getStatusResponse } from "@/components/tableTbody";
import BettingPopup from "../GameRecordsNow/comp/Betting";
import AvatarImage from "@/components/avatarImage";
import { useUserInfo } from "@/hooks/useUserInfo";
import { getUserInfoMethod } from "@/redux/reducers/authSlice";
import IncomePopup from "@/components/income";

type DataType = {
	balance: number;
	inCoin: number;
	outCoin: number;
	coinPnl: number;
	rate: string;
	stateDay: string;
};
const PersonalData: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { showLoading, hideLoading } = showGlobalLoading();
	const { customNavigate } = useRouter();
	const { nickname } = useUserInfo();
	const { userInfo } = useSelector((state: RootState) => state.auth);
	const [giftVisible, setGiftVisible] = useState(false);
	const [show, setShow] = useState(true);
	const [visible, setVisible] = useState(false);
	const currentGame = useRef<Record<string, any>>({});

	const [dataUserDash, setDataUserDash] = useState<DataType>({
		balance: 0,
		inCoin: 0,
		outCoin: 0,
		coinPnl: 0,
		rate: "0",
		stateDay: "",
	});
	const params: any = {
		srcList: ["BUY"],
		pageSize: 8,
	};
	const childRef = useRef<any>(null);
	const { data } = useFinanceOrderList(params, childRef);

	const goToPageHandle = () => {
		// 有返水
		if (has(userInfo?.balance, "3") && (userInfo?.balance["3"] ?? 0) > 0) {
			setGiftVisible(true);
		} else {
			customNavigate("/cashbackRecord");
		}
	};

	const financeUserDash = async () => {
		try {
			showLoading();
			const result: any = await API.finances.apiFinanceUserDash({});
			if (result?.code === 0) {
				const contentData = result.content.data;
				setDataUserDash(contentData);
			}
		} catch (error) {
			console.error("---financeUserDash--:", error);
		} finally {
			hideLoading();
		}
	};

	const toggleTotalAssetsShow = () => {
		setShow((prevShow) => !prevShow);
	};

	const formatStateDay = (stateDay: string | undefined) => {
		const time = stateDay
			? new Date(stateDay).toLocaleString()
			: new Date().toLocaleString();
		return dateFormat(east8ToEast9(time).getTime(), "YYYY-MM-dd hh:mm:ss");
	};

	const splitAndCheck = (str: string, delimiter = "##") => {
		const parts = str.split(delimiter);
		return parts.length >= 3 ? parts[2] : parts[0];
	};

	useEffect(() => {
		const onInit = async () => {
			await dispatch(getUserInfoMethod());
			financeUserDash();
		};
		onInit();
	}, []);

	return (
		<div className="router-main">
			<FixedNavBar title={`${t("PersonalData")}`} />
			<div className="router-view">
				<div className={classes.contentWrap}>
					<div className={classes.infoWrap}>
						<div className="icon">
							<AvatarImage width={48} height={48} />
						</div>
						<span>{nickname}</span>
					</div>
					<div className={classes.totalAssetsWrap}>
						<div className="l">
							<Space
								align="center"
								style={{
									"--gap": pxToRem(6),
									marginBottom: pxToRem(6),
								}}
							>
								<p>{t("TotalAssets")}</p>
								{!show ? (
									<EyeOutline
										fontSize={24}
										color="#868FA8"
										onClick={toggleTotalAssetsShow}
									/>
								) : (
									<EyeInvisibleOutline
										fontSize={24}
										color="#868FA8"
										onClick={toggleTotalAssetsShow}
									/>
								)}
							</Space>
							<Space align="center">
								<strong>
									$
									{show
										? formatNumberWithCommas(
												dataUserDash.balance
										  )
										: "****"}
								</strong>
							</Space>
						</div>
						<Button
							onClick={() => {
								customNavigate("/wallet/1");
							}}
							block
							shape="rounded"
							className={classes.btn}
						>
							<Space
								style={{
									"--gap": pxToRem(6),
								}}
							>
								<Image
									src={require("@/assets/images/icons/wallet.png")}
									className="icon"
								/>
								<span>{t("Wallet")}</span>
							</Space>
						</Button>
					</div>
				</div>
				<div className={classes.columnTitle}>
					<div className="l">
						<Image
							src={require("@/assets/images/icons/pie-chart.png")}
							className="icon"
						/>
						<strong>{t("Count")}</strong>
						{dataUserDash.stateDay && (
							<span>
								{t("LastUpdate", {
									time: formatStateDay(
										dataUserDash?.stateDay
									),
								})}
							</span>
						)}
					</div>
				</div>
				<div className={classes.countWrap}>
					<Grid columns={2} gap={8}>
						<Grid.Item>
							<dl className={classes.cardMonomer}>
								<dt>
									<Image
										src={require("@/assets/images/icons/coins-stacked.png")}
										className="icon"
									/>
									<span>{t("TotalBetAmount")}</span>
								</dt>
								<dd className="u">
									{formatNumberWithCommas(
										dataUserDash.outCoin
									)}{" "}
									USDT
								</dd>
							</dl>
						</Grid.Item>
						<Grid.Item>
							<dl className={classes.cardMonomer}>
								<dt>
									<Image
										src={require("@/assets/images/icons/TotalReward.png")}
										className="icon"
									/>
									<span>{t("TotalRebate")}</span>
								</dt>
								<dd className="u">
									{formatNumberWithCommas(
										dataUserDash.inCoin
									)}{" "}
									USDT
								</dd>
							</dl>
						</Grid.Item>
					</Grid>
				</div>

				<div className={classes.countWrap}>
					<dl className={`${classes.cardMonomer} gradient`}>
						<dt>
							<Image
								src={require("@/assets/images/icons/trophies.png")}
								className="icon"
							/>
							<span style={{ color: "#8BFF78" }}>
								{t("TotalVictory")}
							</span>
						</dt>
						<dd className="u">
							{formatNumberWithCommas(dataUserDash.coinPnl)} USDT
						</dd>
					</dl>
				</div>

				<div className={classes.columnTitle}>
					<div className="l">
						<Image
							src={require("@/assets/images/icons/coins-hand.png")}
							className="icon"
						/>
						<strong>{t("Cashback")}</strong>
					</div>
					<div
						onClick={() => {
							customNavigate("/cashbackRecord");
						}}
						className="more"
					>
						{t("CashbackRecord")} {">>"}
					</div>
				</div>
				<div className={classes.countWrap}>
					<div className={`${classes.cardMonomer} gradient cashback`}>
						<div className="claimed">
							<p>{t("CashbackRatio")}</p>
							<div className="amount">
								<Image
									src={require("@/assets/images/icons/USDT.png")}
									width={24}
									height={24}
								/>
								<span className="value">
									{userInfo?.balance["3"] ?? 0}
								</span>
							</div>
						</div>
						<Image
							src={require("@/assets/images/icons/cashback.png")}
							width={74}
							height={76}
						/>
						<div className="rateBox">
							<Button
								onClick={goToPageHandle}
								className={classes.button}
							>
								{t("CollectCashback")}
							</Button>
							<span>
								{t("RebateRatio")}{" "}
								{userInfo?.rolling ? userInfo?.rolling : 0}%
							</span>
						</div>
					</div>
				</div>

				<div className={classes.columnTitle}>
					<div className="l">
						<Image
							src={require("@/assets/images/icons/record.png")}
							className="icon"
						/>
						<strong>{t("GameRecords")}</strong>
					</div>
					<div
						onClick={() => {
							customNavigate("/gameRecordsNow");
						}}
						className="more"
					>
						{t("ViewAll")} {">>"}
					</div>
				</div>

				{data.length > 0 ? (
					<ul className={classes.listWrap}>
						{data?.map((item, index) => {
							const winLossValue = multiplyWithPrecision(
								item.rewardCoin ?? 0,
								item.coin ?? 0,
								4
							);
							return (
								<li
									onClick={() => {
										currentGame.current = item;
										setVisible(true);
									}}
									key={index}
								>
									<div className="up">
										<Image
											src={require("@/assets/images/icons/coin.png")}
											className="icon"
										/>
										<p>{splitAndCheck(item.refId)}</p>
										<strong
											className={
												winLossValue > 0
													? "win"
													: "lose"
											}
										>
											{formatNumberWithCommas(
												winLossValue
											)}
										</strong>
									</div>
									<div className="down">
										<span>
											{dateFormat(
												east8ToEast9(
													item.updateTime
												).getTime(),
												"YYYY-MM-dd hh:mm:ss"
											)}
										</span>
										<span>
											{
												getStatusResponse(
													item.status,
													t
												).text
											}
										</span>
									</div>
								</li>
							);
						})}
					</ul>
				) : (
					<CustomEmpty />
				)}
			</div>

			{/* <GiftPopup
				visible={giftVisible}
				onClose={() => setGiftVisible(false)}
			/> */}
			<IncomePopup
				income={userInfo?.balance["3"] ?? 0}
				visible={giftVisible}
				onClose={() => setGiftVisible(false)}
			/>

			{!isEmpty(currentGame.current) && (
				<BettingPopup
					visible={visible}
					onClose={() => {
						setVisible(false);
					}}
					data={currentGame.current}
				/>
			)}
		</div>
	);
};

export default PersonalData;

const useStyles = createUseStyles({
	contentWrap: {
		position: "relative",
		padding: {
			top: pxToRem(20),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"&::before": {
			position: "absolute",
			content: '""',
			width: pxToRem(164),
			height: pxToRem(138),
			left: "50%",
			top: pxToRem(20),
			transform: "translateX(-50%) scale(1.6)",
			backgroundImage: `url(${require("@/assets/images/icons/backdrop-filter.png")})`,
			backgroundSize: "100% 100%",
			objectFit: "cover",
		},
	},
	infoWrap: {
		display: "flex",
		alignItems: "center",
		paddingBottom: pxToRem(18),
		"& .icon": {
			borderRadius: "100%",
			border: "1px solid #475278",
			marginRight: pxToRem(14),
		},
		"& span": {
			color: "#FFFFFF",
			fontSize: pxToRem(18),
			fontWeight: 600,
		},
	},
	totalAssetsWrap: {
		position: "relative",
		display: "flex",
		alignItems: "center",
		zIndex: 10,
		border: "1px solid #353F63",
		padding: {
			top: pxToRem(17),
			right: pxToRem(17),
			bottom: pxToRem(20),
			left: pxToRem(20),
		},
		overflow: "hidden",
		// borderImage: "linear-gradient(180deg, #2E3A61 0%, #353F63 100%) 1",
		background: "linear-gradient(156deg, #181B24 5.2%, #232C48 97.46%)",
		borderRadius: pxToRem(10),
		"& .l": {
			display: "flex",
			flexDirection: "column",
			flex: 1,
			"& p": {
				color: "#868FA8",
				fontSize: pxToRem(14),
				fontWeight: 400,
				fontFamily: "Noto Sans SC",
			},
			"& strong": {
				color: "#FFFFFF",
				fontSize: pxToRem(26),
				fontWeight: 600,
			},
		},
	},
	labelTitle: {
		color: "#FFFFFF",
		fontFamily: "Noto Sans SC",
		fontSize: pxToRem(14),
		fontWeight: 500,
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
		},
	},
	btn: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: pxToRem(112),
		height: pxToRem(40),
		fontSize: pxToRem(14),
		fontWeight: "500",
		fontFamily: "Noto Sans SC",
		"--text-color": "#FFFFFF",
		"--border-width": "0",
		background: "linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
		boxShadow:
			"0px 10px 10px 1px #184DED4D, 0px 2px 4px 0px #00C2FF40 inset",
		"& .icon": {
			width: pxToRem(22),
			height: pxToRem(18),
		},
	},
	columnTitle: {
		display: "flex",
		justifyContent: "space-between",
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			top: pxToRem(15),
			bottom: pxToRem(15),
		},
		"& .l": {
			flex: 1,
			overflow: "hidden",
			display: "flex",
			alignItems: "center",
			"& .icon": {
				width: pxToRem(24),
				height: pxToRem(24),
				marginRight: pxToRem(8),
			},
			"& strong": {
				color: "#FFFFFF",
				fontFamily: "Noto Sans SC",
				fontSize: pxToRem(14),
				fontWeight: 500,
			},
			"& span": {
				color: "#868FA8",
				fontSize: pxToRem(12),
				fontWeight: 400,
				marginLeft: pxToRem(8),
			},
		},
		"& .more": {
			color: "#868FA8",
			fontSize: pxToRem(14),
			fontWeight: 400,
		},
	},

	countWrap: {
		padding: {
			right: pxToRem(20),
			left: pxToRem(20),
		},
		marginBottom: pxToRem(10),
	},
	cardMonomer: {
		padding: {
			top: pxToRem(15),
			right: pxToRem(10),
			bottom: pxToRem(10),
			left: pxToRem(16),
		},
		borderRadius: pxToRem(10),
		backgroundColor: "#181A20",
		"&.gradient": {
			background: "linear-gradient(90deg, #147639 0%, #1E2846 100%)",
			"& dt": {
				color: "#FFFFFF",
			},
		},
		"&.cashback": {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			position: "relative",
			"& .claimed": {
				display: "flex",
				flexDirection: "column",
				"& >p": {
					color: "#8BFF78",
					fontFamily: "Noto Sans SC",
					fontWeight: 400,
					fontSize: pxToRem(12),
					marginBottom: pxToRem(14),
				},

				"& .amount": {
					display: "flex",
					alignItems: "center",
					gap: pxToRem(8),
					"& .value": {
						color: "#FFFFFF",
						fontWeight: 700,
						fontSize: pxToRem(18),
						lineHeight: pxToRem(34),
					},
				},
			},
			"& .rateBox": {
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "space-between",
				"& >span": {
					color: "#868FA8",
					fontFamily: "Poppins",
					fontWeight: 400,
					fontSize: pxToRem(10),
					marginTop: pxToRem(4),
					textTransform: "capitalize",
				},
			},
		},
		"& dt": {
			display: "flex",
			alignItems: "center",
			color: "#868FA8",
			fontSize: pxToRem(12),
			fontWeight: 400,
			"& .icon": {
				width: pxToRem(20),
				height: pxToRem(20),
				marginRight: pxToRem(4),
			},
		},
		"& dd": {
			color: "#FFFFFF",
			fontSize: pxToRem(14),
			fontWeight: 500,
			lineHeight: pxToRem(34),
			"&.u": {
				fontSize: pxToRem(18),
				fontWeight: 700,
			},
		},
	},
	button: {
		minWidth: pxToRem(112),
		height: pxToRem(40),
		borderRadius: pxToRem(40),
		color: "#fff",
		fontFamily: "Noto Sans SC",
		fontWeight: 500,
		fontSize: pxToRem(14),
		background: "#46D030",
		"--border-style": "none",
	},
	listWrap: {
		"& li": {
			borderTop: "1px solid #2F3A62",
			padding: {
				top: pxToRem(16),
				left: pxToRem(20),
				right: pxToRem(22),
				bottom: pxToRem(20),
			},
			"& >div": {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
			},
		},
		"& .up": {
			fontWeight: 500,
			marginBottom: pxToRem(3),
			"& .icon": {
				width: pxToRem(20),
				height: pxToRem(20),
				marginRight: pxToRem(6),
				border: "1px solid",
				borderImageSource:
					"linear-gradient(180deg, #4270F7 0%, #153AA8 100%)",
			},
			"& p": {
				flex: 1,
				overflow: "hidden",
				color: "#FFFFFF",
				fontSize: pxToRem(16),
			},
			"& strong": {
				fontSize: pxToRem(16),
			},
		},
		"& .down": {
			color: "#868FA8",
			fontWeight: 400,
			fontSize: pxToRem(12),
		},
	},
});
